module.exports = __webpack_public_path__ + "img/mobile-scan.c0ada5f3.svg";